import { DataList, DataItem } from '@cad-arc'
import { UnitStatusSearchRow } from '@mark43/cad-api';
import { ExpandableContent } from './expandable-content';

export function UnitStatusSearchResultsLocationCell({
    row,
    isExpanded,
}: {
    row: UnitStatusSearchRow;
    isExpanded: boolean;
}) {
    return (
        <DataList>
            {row.statusLocation && (
                <DataItem dataKey="Status" style={{ whiteSpace: 'normal' }}>
                    {row.statusLocation}
                </DataItem>
            )}
            {row.eventLocation && <DataItem dataKey="Event">{row.eventLocation}</DataItem>}
            <ExpandableContent isExpanded={isExpanded}>
                {row.unitLocation && <DataItem dataKey="Unit">{row.unitLocation}</DataItem>}
            </ExpandableContent>
        </DataList>
    );
}
